.root {
  align-items: center;
  border-radius: 6px;
  cursor: pointer;
  display: inline-flex;
  font-size: 14px;
  gap: 10px;
  padding: 8px 12px;
}

.root-is-checked {
  background: var(--color-secondary);
  font-weight: 500;
}

.input {
  accent-color: var(--color-accent-foreground);
  height: 16px;
  width: 16px;
}

.label {
  color: var(--color-foreground);
}
